import { Device } from '@twilio/voice-sdk';
function resetCallButtonsss() {
    const answerBtn = document.getElementById('answerBtn');
    const declineBtn = document.getElementById('declineBtn');

    if (answerBtn) answerBtn.style.display = 'block';
    if (declineBtn) declineBtn.style.width = 'auto';
}
class TwilioVoiceApp {
    constructor(token) {
        this.device = null;
        this.activeCall = null;
        this.toggleMute = this.toggleMute.bind(this);
        document.addEventListener('click', (e) => {
            if (e.target.closest('#muteContainer')) {
                this.toggleMute();
            }
        });
        this.isRegistered = false;
        this.initializeApp(token)
    }

    async initializeApp(token) {
        try {
            this.updateStatus('Initializing...', 'connecting');

            // Get token from your server
            this.initializeDevice(token);

        } catch (error) {
            console.error('Initialization failed:', error);
            this.updateStatus('Initialization failed', 'error');
        }
    }

    async initializeDevice(token) {
        this.token = token;
        console.log("token in initializeDevice")
        // console.log(token)
        this.device = new Device(token, {
            codecPreferences: ['opus', 'pcmu'],
            debug: true,
            fakeLocalDTMF: true,
            enableRingingState: true
        });

        this.setupDeviceListeners();

        this.device.register()
            .then(() => {
                this.isRegistered = true;
                this.updateStatus('Ready to make calls', 'ready');
                this.enableCallButton();
            })
            .catch(error => {
                console.error('Registration failed:', error);
                this.updateStatus('Registration failed', 'error');
            });
    }

    setupDeviceListeners() {
        this.device.on('registered', () => {
            console.log('Device registered');
            this.updateStatus('Connected', 'ready');
        });

        this.device.on('error', (error) => {
            console.error('Device error:', error);
            this.updateStatus(`Error: ${error.message}`, 'error');
        });

        this.device.on('incoming', (call) => {
            console.log('Incoming call from:', call.parameters.From);
            this.handleIncomingCall(call);
        });

        this.device.on('disconnect', () => {
            console.log('Call disconnectedsdfsds');
            this.updateStatus('Call ended', 'ready');
            this.activeCall = null;
        });

        this.device.on('cancel', () => {
            console.log('Call cancelled');
            this.updateStatus('Call cancelled', 'ready');
            this.activeCall = null;
        });

    }

   handleIncomingCall(call) {
    if (this.activeCall) {
        console.warn("Incoming call detected. Disconnecting active call...");
        this.activeCall.disconnect();
    }

    this.activeCall = call;

    // 2. Cleanup (Sirf ek baar UI call karein)
    this.cleanupCallUI(); 
    
    // UI Logic
    const callerNumber = call.parameters.From || 'Unknown';
    let call_from = document.getElementById('call_from');
    if(call_from) call_from.textContent = callerNumber;

    this.updateStatus('Incoming Call', 'active');
    this.showIncomingCallUI(call);
    this.setupCallListeners(call);

    // Notification Logic (Sahi hai)
    if ("Notification" in window && Notification.permission === "granted") {
        new Notification("New Incoming Call", { body: "From: " + callerNumber });
    }

    call.on('accept', () => this.updateStatus('Call connected', 'active'));
    
    call.on('disconnect', () => {
        this.activeCall = null;
        this.cleanupCallUI();
        this.updateStatus('Call ended', 'ready');
    });

    call.on('cancel', () => this.cleanupCallUI());
    call.on('reject', () => this.cleanupCallUI());
}

    // the model cleanup
  cleanupCallUI() {
    console.log("Cleaning up UI and resetting states...");
    
    // 1. Focus hatayein
    if (document.activeElement) document.activeElement.blur();

    // 2. SARE modals hide karein (taake koi piche na reh jaye)
    $("#incoming-call").modal("hide");
    $("#call1").modal("hide");
    $("#startcall").modal("hide"); 

    // 3. Timer stop karein
    if (typeof this.stopCallTimer === 'function') {
        this.stopCallTimer();
    }

    // 4. Mute icon/text reset
    const muteIcon = document.getElementById('muteIcon');
    const muteText = document.getElementById('muteText');

    if (muteIcon) {
        muteIcon.className = "bi bi-mic-fill fs-5";
    }
    if (muteText) {
        muteText.textContent = "Mute";
    }

    // 5. State Reset (Sabse ahem)
    this.activeCall = null;
    this.updateStatus('Ready', 'ready');
}
  showIncomingCallUI(call) {
    // 1. Modal show karein
    $("#incoming-call").modal("show");

    // 2. Clear old handlers to prevent memory leaks/multiple triggers
    const answerBtn = document.getElementById('answerBtn');
    const declineBtn = document.getElementById('declineBtn');

    // Button handlers ko reset karein (overwrite)
    answerBtn.onclick = () => {
        console.log("Answering call...");
        call.accept();
        this.updateStatus('Call connected', 'active');
        this.startCallTimer();
        // Modal hide yahan hona chahiye
        $("#incoming-call").modal("hide");
    };

    declineBtn.onclick = () => {
        console.log("Declining call...");
        if (call) {
            // Twilio incoming call ke liye reject() hi use hota hai
            call.reject(); 
        }
        this.cleanupCallUI();
    };

    // 3. Listener ka cleanup
    // 'disconnect' event ko yahan baar baar attach na karein, 
    // ye 'handleIncomingCall' ya 'setupCallListeners' mein hona chahiye.
    // Agar yahan rakhna hi hai, to 'once' ka use karein.
    call.once('disconnect', () => {
        console.log("Call disconnected by remote party.");
        this.cleanupCallUI();
    });
}



    // mute
    toggleMute() {
        if (!this.activeCall) return;
        const isMuted = this.activeCall.isMuted();
        this.activeCall.mute(!isMuted);
        const muteIcon = document.getElementById('muteIcon');
        // const muteText = document.getElementById('muteText');

        if (!isMuted) {
            muteIcon.className = "bi bi-mic-mute-fill fs-5 text-danger";
            // muteText.textContent = "Unmute";
        } else {
            muteIcon.className = "bi bi-mic-fill fs-5";
            // muteText.textContent = "Mute";
        }
    }

    updateStatus(message, type) {
        // Find or create status element
        let statusEl = document.getElementById('status');
        let status1 = document.getElementById('status1');


        if (!statusEl) {
            statusEl = document.createElement('div');
            statusEl.id = 'status';
            document.body.prepend(statusEl);

            status1 = document.createElement('div');
            status1.id = 'status';
            document.body.prepend(status1);
        }
        statusEl.textContent = message;
        statusEl.className = type;

        status1.textContent = message;
        status1.className = type;
    }
    enableCallButton() {
        const btn = document.getElementById('button-call');
        const btn2 = document.getElementById('button-call12');
        if (btn) btn.disabled = false;
        if (btn2) btn2.disabled = false;

    }

    async fetchToken() {
        // Replace with your actual token endpoint
        const response = await fetch('/voice/token');
        if (!response.ok) {
            throw new Error('Failed to fetch token');
        }
        const data = await response.json();
        return data.token;
    }

    async makeCall(phoneNumber) {
        // if (!this.isRegistered) {
        //     this.updateStatus('Device not registered yet', 'error');
        //     return;
        // }

        // const phoneNumber = this.elements.phoneNumber.value.trim();
        if (!phoneNumber) {
            alert('Please enter a phone number');
            return;
        }

        try {
            this.updateStatus('Dialing...', 'connecting');
            // this.disableCallButton();
            // this.enableHangupButton();

            // Make the call
            this.startCallTimer();
            this.activeCall = await this.device.connect({
                params: {
                    To: phoneNumber
                }
            });

            this.setupCallListeners(this.activeCall);
            console.log('Call initiated:', this.activeCall);

        } catch (error) {
            console.error('Call failed to start:', error);
            this.updateStatus('Call failed: ' + error.message, 'error');
            this.resetCallUI();
        }
    }


    startCallTimer() {
        console.log("--- Initializing New Call Timer ---");

        // 1. KILL any existing intervals (prevents "Double Speed")
        if (this.callTimerInterval) {
            clearInterval(this.callTimerInterval);
            this.callTimerInterval = null;
        }
        // 2. WIPE the data (prevents "Showing Last Call Seconds")
        this.elapsedSeconds = 0;
        this.callStartTime = new Date();

        // 3. FLUSH the UI (prevents "Ghost Numbers")
        // This forces the screen to show 00:00 immediately
        this.updateCallTimerDisplay();

        // 4. START the fresh heartbeat
        this.callTimerInterval = setInterval(() => {
            // We use the System Clock calculation because it is impossible to run "fast"
            const now = new Date();
            this.elapsedSeconds = Math.round((now - this.callStartTime) / 1000);

            this.updateCallTimerDisplay();
        }, 1000);
    }
    stopCallTimer() {
        if (this.callTimerInterval) {
            clearInterval(this.callTimerInterval);
            this.callTimerInterval = null;
        }
        this.elapsedSeconds = 0;

        // Clear the UI so it shows 00:00 or empty after hangup
        const timerIds = ['callTimer', 'callTimer1', 'callTimerWidget'];
        timerIds.forEach(id => {
            let el = document.getElementById(id);
            if (el) el.textContent = "00:00";
        });
    }
    updateCallTimerDisplay() {
        const formattedTime = this.formatTime(this.elapsedSeconds);
        const timerIds = ['callTimer', 'callTimer1', 'callTimerWidget'];

        timerIds.forEach(id => {
            let element = document.getElementById(id);
            if (element) { // Only update if the element actually exists on this page
                element.textContent = formattedTime;
            }
        });
    }
    // updateCallTimerDisplay() {
    //     const formattedTime = this.formatTime(this.elapsedSeconds);
    //     let callTimer = document.getElementById('callTimer');
    //     callTimer.textContent = formattedTime;

    //     let callTimer1 = document.getElementById('callTimer1');
    //     callTimer1.textContent = formattedTime;

    //     let callTimerWidget = document.getElementById('callTimerWidget');
    //     callTimerWidget.textContent = formattedTime;

    //     // Update call info with duration
    //     // if (this.elements.callInfo) {
    //     //     this.elements.callInfo.textContent = `Call duration: ${formattedTime}`;
    //     // }
    // }



    formatTime(totalSeconds) {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        if (hours > 0) {
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        } else {
            return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        }
    }



    hangUp() {
        console.log("Hangup initiated...");

        // 1. Try the standard way
        if (this.activeCall) {
            this.activeCall.disconnect();
            this.activeCall = null;
        }

        // 2. THE BACKUP (Use this if the standard way fails)
        // 'this.device' is the Twilio.Device object you created at the start
        if (this.device) {
            console.log("Forcing global disconnect via Device...");
            this.device.disconnectAll();
        }

        // 3. Force UI to reset no matter what
        this.stopCallTimer();
        $(".modal").modal("hide");
    }

    setupCallListeners(call) {
        // Call connected successfully
        console.log(call)
        let callInfo = document.getElementById('callInfo');
        call.on('accept', (call) => {
            console.log(call)
            console.log('Call accepted and connected');
            this.updateStatus('Call connected', 'active');

            // Answer button hide
            document.getElementById('answerBtn').style.display = 'none';

            console.log("Call accepted. Only hangup button visible.");
            // callInfo.textContent = `Connected to: ${call.parameters.To}`;
            // this.enableMuteButton();
        });
        call.on('disconnect', () => {
            console.log("Call disconnected signal received from Twilio.");


            // disconnect event to everyone in the call.
            $("#call1").modal("hide");
            $("#incoming-call").modal("hide");

            this.updateStatus('Call ended', 'ready');
            this.resetCallButtons();
        });
        // if call was canceled
        call.on('cancel', () => {
            console.log("Call was canceled.");
            $("#incoming-call").modal("hide");
        });
        // Call ended
        //     call.on('disconnect', (call) => {

        //         this.updateStatus('Call ended', 'ready');
        //         //  $(document).on('hidden.bs.modal', '#call1', function () {
        //         //     $('.modal-backdrop').remove(); // This should now work reliably
        //         // });
        //         // $("#call1").modal("hide");
        //         // $("#out-button-hangup").click()
        //         // this.hideModal('call1'); 


        //         try {
        //     // Method 1: Try Bootstrap first
        //     if (typeof $ !== 'undefined' && $.fn.modal) {
        //         $('#call1').modal('hide');
        //         $("#out_going_widget").hide()
        //         // Ensure backdrop is removed

        //         setTimeout(() => {
        //             $('body').removeClass('modal-open');
        //             $('.modal-backdrop').remove();
        //         }, 100);
        //     } 
        //     // Method 2: Fallback to manual DOM manipulation
        //     else {
        //         console.log('Call disconnected');
        //         const modal = document.getElementById('call1');
        //         if (modal) {
        //             modal.style.display = 'none';
        //             modal.classList.remove('show');
        //         }
        //         $("#out_going_widget").hide()
        //         document.body.classList.remove('modal-open');
        //         const backdrops = document.querySelectorAll('.modal-backdrop');
        //         backdrops.forEach(backdrop => backdrop.remove());
        //     }
        // } catch (error) {
        //     console.error('Error hiding modal:', error);
        // }


        // const duration = this.stopCallTimer();
        //     // callInfo.textContent = `Call duration: ${duration}`;
        //     $("#button-call12").show()
        //     // const duration = call.duration ? `Duration: ${call.duration}s` : 'Call ended';
        //     // callInfo.textContent = duration;
        //     // this.resetCallUI();
        //     this.activeCall = null;
        // });



        // Call error
        call.on('error', (error) => {
            console.error('Call error:', error);
            this.updateStatus('Call error: ' + error.message, 'error');
            this.resetCallUI();
            this.activeCall = null;
        });

        // Call quality monitoring
        call.on('sample', (sample) => {
            this.monitorCallQuality(sample);
        });

        // Reconnecting events
        call.on('reconnecting', (error) => {
            console.log('Call reconnecting...', error);
            this.updateStatus('Reconnecting...', 'connecting');
        });

        call.on('reconnected', () => {
            console.log('Call reconnected');
            this.updateStatus('Call reconnected', 'active');
        });
    }

    hideModal(modalId) {
        const modalElement = document.getElementById(modalId);
        if (modalElement) {
            // Use Bootstrap's modal method if available
            if (typeof jQuery !== 'undefined' && jQuery.fn.modal) {
                $(modalElement).modal('hide');
                // Force remove backdrop
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
            } else {
                // Fallback: hide manually
                modalElement.style.display = 'none';
                modalElement.classList.remove('show');
                document.body.classList.remove('modal-open');
                const backdrops = document.querySelectorAll('.modal-backdrop');
                backdrops.forEach(backdrop => backdrop.remove());
            }
        }
    }

    monitorCallQuality(sample) {
        // Monitor call quality metrics
        const packetLoss = (sample.packetsLost / sample.totalPackets) * 100;
        const jitter = sample.jitter;
        let callInfo = document.getElementById('callInfo');
        let qualityStatus = '';
        if (packetLoss > 10 || jitter > 50) {
            qualityStatus = ' (Poor connection)';
        } else if (packetLoss > 5 || jitter > 20) {
            qualityStatus = ' (Fair connection)';
        } else {
            qualityStatus = ' (Good connection)';
        }

        // Update call info with quality
        const currentText = callInfo.textContent;
        if (!currentText.includes('connection)')) {
            callInfo.textContent += qualityStatus;
        }
    }

    resetCallButtons() {
        const answerBtn = document.getElementById('answerBtn');
        const declineBtn = document.getElementById('declineBtn');

        if (answerBtn) answerBtn.style.display = 'block';
        if (declineBtn) declineBtn.style.width = 'auto';
    }


}

// Initialize when DOM is loaded
// document.addEventListener('DOMContentLoaded', () => {
// new TwilioVoiceApp();
// });

window.TwilioVoiceApp = TwilioVoiceApp;